<template>
  <footer class="page-footer font-small blue pt-4">
    <div class="footer-copyright text-center py-3">
      © <a href="http://metromobility.io">Metro Mobility</a> 2019
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
  footer {
    background-color: #f8f9fa;
  }

  a {
    color: #3dcd9b;
  }
</style>